import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import { buildProfileUrl } from '../utils/url';

const Link = ({
    profileType,
    name,
    title,
    shortName,
    uid,
    className,
    children,
    whenEmpty = '—'
}) => (
    uid && name ? (
        <a
            className={classNames('ui-link ui-link_table js-popupLink', className)}
            href={buildProfileUrl(uid, name, profileType)}
            title={title}
        >
            {children || shortName || name}
            <Svg
                iconName="right"
                size="smallChevron"
            />
        </a>
    ) : (
        <span>{whenEmpty}</span>
    )
);

Link.propTypes = {
    profileType: PropTypes.string.isRequired,
    name: PropTypes.string,
    shortName: PropTypes.string,
    uid: PropTypes.number,
    className: PropTypes.oneOfType(
        [PropTypes.string, PropTypes.bool]
    ),
    title: PropTypes.string,
    children: PropTypes.node,
    whenEmpty: PropTypes.string
};

const profileTypes = ['trainer', 'owner', 'jockey', 'horse', 'course'];

/* eslint react/prop-types: 0 */
const ProfileLink = profileTypes.reduce((res, type) => Object.assign(res, {
    [type]: props => (
        <Link
            profileType={type}
            uid={props[`${type}Uid`]}
            name={props[`${type}StyleName`]}
            shortName={props[`${type}ShortName`]}
            className={props.className}
            whenEmpty={props.whenEmpty}
            title={props.title}
        >
            {props.children}
        </Link>
    )
}), {});

export const CourseLink = ProfileLink.course;
export const HorseLink = ProfileLink.horse;
export const JockeyLink = ProfileLink.jockey;
export const OwnerLink = ProfileLink.owner;
export const TrainerLink = ProfileLink.trainer;

export default ProfileLink;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/links/ProfileLink.jsx